module.exports = __webpack_public_path__ + "img/ic_bed2.4bd7f43c.svg";